<div class="row me-3 d-flex" [ngClass]="{ 'selected': selected(), 'disabled': disabled() }">
  <button class="button col-6 mx-2" [id]="paymentOption().id" (click)="selectPaymentOption()">
    <span class="disclaimer-bold">{{ paymentOption().caption }}</span>
  </button>
</div>
